@if (!isProd) {
  <ndt-toolbar
    data-test-id="devToolbar"
    [config]="{
      showFeatureFlagsTool: true,
      showPermissionsTool: true,
    }"
  >
    <ndt-toolbar-tool
      title="Settings"
      icon="gear"
      [options]="{
        id: 'testId',
        title: 'foobar',
        size: 'large',
      }"
    >
      <p>This is a custom tool</p>
    </ndt-toolbar-tool>
  </ndt-toolbar>
}

<router-outlet />
<dialog
  #errorDialog
  [open]="errorService.error"
  (mousedown)="$event.target === errorDialog && errorDialog.close()"
>
  <div
    class="flex max-w-[800px] flex-col items-end gap-6 rounded-xl bg-white px-8 py-6"
  >
    <div class="prose w-full">
      <h2 class="flex items-start gap-3 text-red-600">
        <svg-icon
          src="assets/icons/Alerts_feedback/alert-circle.svg"
          class="size-12 shrink-0 text-red-600"
        />
        <span class="pt-1">{{ 'app.errorDialog.title' | translate }}</span>
      </h2>
      <p class="max-w-xl">{{ 'app.errorDialog.content' | translate }}</p>
    </div>
    @if (!isProd) {
      <div class="prose w-full">
        <p data-test-id="errorMessage" class="text-xl font-bold">
          {{ errorService.error?.status }} {{ errorService.error?.statusText }}
        </p>
        @if (errorService.error?.error?.error) {
          <dl data-test-id="extendedInformation">
            <dt>Type</dt>
            <dd>{{ errorService.error?.error.error?.type }}</dd>
            <dt>Message</dt>
            <dd>{{ errorService.error?.error.error?.message }}</dd>
            @if (errorService.error?.error.error.query) {
              <dt>Query</dt>
              <dd>
                <pre
                  class="m-0 p-0"
                ><code language="json" [highlight]="errorService.error?.error.error.query | json"></code></pre>
              </dd>
            }
          </dl>
        }
      </div>
    }
    <app-button
      data-test-id="closeButton"
      type="outline"
      class="w-auto"
      (trigger)="errorDialog.close()"
    >
      <svg-icon prefix src="assets/icons/General/x-close.svg" class="size-5" />
      {{ 'app.errorDialog.closeButton.label' | translate }}
    </app-button>
  </div>
</dialog>
